import { Component, OnInit, ViewChild, ElementRef, Injector } from '@angular/core';
import {
  ViewDataService,
  ViewDataConfigStruct,
  EventListLocator,
  LoggedComponent,
  ExtendedEventBaseItem
} from 'world-archery-lib';
import { LoggerService } from 'world-archery-lib';
import { Observable } from 'rxjs';
import { CalendarFilterService } from '../../services/calendar-filter.service';
import { first, filter } from 'rxjs/operators';
import { EventsStore } from '../../../../common-page-components/stores/entities-store/events-store';
import { HttpClient } from '@angular/common/http';
import { WaHelperService } from '../../../../library/wa-services/wa-helper-service';
import { DrupalLangClass } from '../../../../common-page-components/classes/drupal-lang-class';

/**
 * List of featured events.
 */
@Component({
  selector: 'app-featured-events',
  templateUrl: './featured-events.component.html',
  styleUrls: ['./featured-events.component.scss']
})
export class FeaturedEventsComponent extends DrupalLangClass implements OnInit {

  /**
   * Viewchild ofr reference to carousel.
   *
   * @type {ElementRef}
   * @memberof FeaturedEventsComponent
   */
  @ViewChild('carousel', { static: false }) container: ElementRef;
  /**
   * List of featured events.
   */
  featuredEventsList: Array<any> = [];
  maxhHeight: number;
  /**
   * Configuration used to build the view.
   */
  ViewConfiguration: ViewDataConfigStruct = {
    maxAge: 1800,
    interval: undefined,
    autorefresh: false,
    expectedItems: 100
  };

  /**
   * Slide configuration.
   * http://kenwheeler.github.io/slick/
   */
  slideConfig = {
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    dots: true,
    responsive: [{
      breakpoint: 700,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }]
  };

  /**
   * Featured events store.
   *
   * @memberof FeaturedEventsComponent
   */
  featuredEvents = new EventsStore(this.http, this.helper, this.injector);

  /**
   * Initializes component.
   *
   * @param logger
   *   Logger.
   * @param views
   *   Event lists view provider.
   * @param filter_service
   *   Filter service.
   */
  constructor(
    protected views: ViewDataService,
    private helper: WaHelperService,
    protected filter_service: CalendarFilterService,
    private http: HttpClient,
    private injector: Injector
  ) {
    super(injector);
  }



  /**
   * Instantiate featured events list.
   */
  ngOnInit() {
    this.getLocator().subscribe();
    this.featuredEvents.dataStream.asObservable().pipe(filter(a => a != undefined)).subscribe(next => {
      this.featuredEventsList = Array.from(next);
    })
  }


  /**
   * Get locator for event list.
   *
   * Filter by the featured events from now on.
   */
  getLocator(): Observable<any> {
    const today = new Date();
    return this.featuredEvents.requestData({
      'Featured': 1,
      'SortBy': 'DATE',
      'Detailed': 1,
      'RBP': 15,
      'StartDate': String(new Date(today.getTime() - today.getTimezoneOffset() * 60000).toISOString()).slice(0, 10),
    }, false);
  }


}
